import { _ as e } from "./tslib.es6-7f1b1220.js";
import { c as t, u as n, h as a, n as r } from "./lit-element-161a1699.js";
import { p as o, q as i, c as s } from "./decorators-7e9cd43b.js";
import { BaseElement as l } from "./BaseElement.esm.min.js";
import { h as u } from "./host.styles-cf05db22.js";
import { e as d } from "./event.decorator-98549cbc.js";
import "./menubar-item-base.class.esm.min.js";
import "./menubar-item.esm.min.js";
import "./menubar-nav-item.component.esm.min.js";
const h = t`${n(":host {\n  --zui-menubar-background-color: var(--zui-color-third-hierarchy-bg-default-primary-enabled);\n  ---zui-menubar-default-width: calc(var(--zui-gu) * 8);\n  ---zui-menubar-opened-default-width: calc(var(--zui-gu) * 35);\n  ---zui-menubar-nav-item-default-height: calc(var(--zui-gu) * 8);\n  background-color: var(--zui-menubar-background-color);\n  height: 100%;\n  transition: width 100ms ease-in-out;\n  width: var(--zui-menubar-width, var(---zui-menubar-default-width));\n}\n\n:host([disabled]) {\n  opacity: 0.5;\n  pointer-events: none;\n}\n:host([disabled]) .menubar-toggle {\n  opacity: 0.5;\n}\n\n:host(:not([disabled])) .menubar-toggle:hover {\n  background-color: var(--zui-color-third-hierarchy-bg-default-primary-hovered);\n  cursor: pointer;\n}\n:host(:not([disabled])) .menubar-toggle:active {\n  background-color: var(--zui-color-third-hierarchy-bg-default-primary-pressed);\n}\n\n:host([opened]) {\n  width: var(--zui-menubar-opened-width, var(---zui-menubar-opened-default-width));\n}\n\n:host([variant=secondary]) {\n  --zui-menubar-background-color: var(--zui-color-third-hierarchy-bg-default-enabled);\n}\n:host([variant=secondary]) .menubar-toggle {\n  color: var(--zui-color-text-default);\n}\n:host([variant=secondary]) .menubar-toggle:hover {\n  background-color: var(--zui-color-third-hierarchy-bg-default-hovered);\n}\n:host([variant=secondary]) .menubar-toggle:active {\n  background-color: var(--zui-color-third-hierarchy-bg-default-pressed);\n}\n\n.menubar {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.menubar-toggle {\n  align-items: center;\n  background-color: var(--zui-menubar-background-color);\n  border: 0;\n  color: var(--zui-color-text-menu-bar-default-primary);\n  display: flex;\n  height: var(--zui-menubar-nav-item-height, var(---zui-menubar-nav-item-default-height));\n  justify-content: center;\n  width: var(--zui-menubar-width, var(---zui-menubar-default-width));\n}\n.menubar-toggle:focus {\n  outline: none;\n}")}`;
let c = class extends l {
  constructor() {
    super(...arguments), this.selected = null, this.disabled = !1, this.variant = "primary", this.emphasis = "default", this.expandable = !1, this.opened = !1, this.autoClose = !1;
  }
  static get styles() {
    return [u, h];
  }
  emitInputEvent(e) {
    this.dispatchEvent(new CustomEvent("input", {
      detail: e
    }));
  }
  emitChangeEvent(e) {
    this.dispatchEvent(new CustomEvent("change", {
      detail: e
    }));
  }
  _propagateValues() {
    this._assignedMenuItems.forEach(e => {
      e.variant = this.variant, this.selected && (e.emphasis = "default", e.value === this.selected && (e.emphasis = this.emphasis)), e.disabled = this.disabled, "zui-menubar-nav-item" === e.tagName.toLowerCase() && (e.opened = this.opened);
    });
  }
  _handleSlotChange() {
    this._propagateValues();
  }
  _handleMenubarItemSelected(e) {
    this.autoClose && this.opened && (this.opened = !1), this.selected = e.detail.value, this.emitChangeEvent(this.selected), this.emitInputEvent(this.selected);
  }
  _handleToggleMenubar() {
    this.opened = !this.opened;
  }
  _menubarToggleButton(e) {
    return e ? a`<button class="menubar-toggle" type="button" @click="${this._handleToggleMenubar}">${this.opened ? a`<zui-icon-arrow-outline-arrow-outline-visually-centered-left size="m"></zui-icon-arrow-outline-arrow-outline-visually-centered-left>` : a`<zui-icon-arrow-outline-arrow-outline-visually-centered-right size="m"></zui-icon-arrow-outline-arrow-outline-visually-centered-right>`}</button>` : r;
  }
  updated(e) {
    super.updated(e), this._propagateValues();
  }
  render() {
    return a`<nav id="menubar" class="menubar"><div class="menubar-items"><slot @slotchange="${this._handleSlotChange}" @menubar-item-selected="${this._handleMenubarItemSelected}"></slot></div>${this._menubarToggleButton(this.expandable)}</nav>`;
  }
};
e([o({
  reflect: !0,
  type: String
})], c.prototype, "selected", void 0), e([o({
  reflect: !0,
  type: Boolean
})], c.prototype, "disabled", void 0), e([o({
  reflect: !0,
  type: String
})], c.prototype, "variant", void 0), e([o({
  reflect: !0,
  type: String
})], c.prototype, "emphasis", void 0), e([o({
  reflect: !0,
  type: Boolean
})], c.prototype, "expandable", void 0), e([o({
  reflect: !0,
  type: Boolean
})], c.prototype, "opened", void 0), e([o({
  reflect: !0,
  type: Boolean,
  attribute: "auto-close"
})], c.prototype, "autoClose", void 0), e([d()], c.prototype, "emitInputEvent", null), e([d()], c.prototype, "emitChangeEvent", null), e([i("", !0, "[zui-internal-is-menubar-item]")], c.prototype, "_assignedMenuItems", void 0), c = e([s("zui-menubar")], c);
class m extends c {
  constructor() {
    super(), console.warn("The usage of MenuBar has been deprecated and it will be removed in the next major release! It has been renamed to Menubar");
  }
  connectedCallback() {
    super.connectedCallback(), console.warn("The usage of MenuBar has been deprecated and it will be removed in the next major release! It has been renamed to Menubar");
  }
}
export { m as MenuBar, c as Menubar };
